import { IsEnum, IsString } from 'class-validator';
import { EntityVm } from 'api/core/entity.vm';

export enum AreaTypeEnum {
  DISPATCH = 'DISPATCH',
  PREPARED = 'PREPARED',
  RECEPTION = 'RECEPTION',
  PREPARATION = 'PREPARATION',
}

export class AreaVm extends EntityVm {
  @IsString()
  warehouseId: string;

  @IsString()
  name: string;

  @IsEnum(AreaTypeEnum)
  type: AreaTypeEnum;
}
